import * as React from "react";
import type { SVGProps } from "react";
const SvgSun03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 5.514V2.4m0 19.2v-3.114M18.486 12H21.6M2.4 12h3.114m11.073-4.586 2.201-2.202M5.211 18.788l2.202-2.201m9.174 0 2.201 2.201M5.211 5.212l2.202 2.201m8.156 4.46a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0"
    />
  </svg>
);
export default SvgSun03;
